import { Link } from 'react-router-dom';

// Wilman archive (spec §13 + §22). Lists every trip the framework has
// ever run. Currently juneau-2026 is the only entry. Future trips
// arrive by dropping a folder into /trips and adding a row here. The
// archive is the cross-trip browser — each card opens that trip's
// permanent slideshow.

const TRIPS = [
  {
    id: 'juneau-2026',
    name: 'Juneau, Alaska',
    tagline: 'Three nights, three idiots, one grumpy producer',
    dates: '2026-05-26 → 2026-05-29',
    slideshow_path: '/slideshow/juneau-2026',
    status: 'in_flight',
  },
];

const STATUS_CHIP = {
  in_flight: { label: 'in flight', cls: 'border-action/40 bg-action/10 text-action' },
  complete: { label: 'complete', cls: 'border-success/40 bg-success/10 text-success' },
  archived: { label: 'archived', cls: 'border-border-tertiary bg-bg-secondary text-fg-tertiary' },
};

export default function Archive() {
  return (
    <div className="min-h-screen bg-bg-primary text-fg-primary">
      <header className="border-b border-border-tertiary bg-bg-primary/95 px-4 py-4 backdrop-blur">
        <div className="mx-auto max-w-screen-md">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-fg-tertiary">
            Mr. Wilman&apos;s archive
          </p>
          <h1 className="mt-1 font-serif text-2xl">Some Say · trips on file</h1>
          <p className="mt-1 text-sm text-fg-secondary">
            Every trip ever produced. Permanent slideshows, no warmth. Future trips arrive here
            automatically by dropping a configuration folder into the repo.
          </p>
        </div>
      </header>
      <main className="mx-auto max-w-screen-md p-4">
        <ul className="space-y-3">
          {TRIPS.map((t) => (
            <li key={t.id} className="card overflow-hidden">
              <header className="flex items-baseline justify-between gap-3 border-b border-border-tertiary bg-bg-secondary px-4 py-3">
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">
                    {t.dates}
                  </p>
                  <h2 className="mt-1 font-serif text-lg">{t.name}</h2>
                </div>
                <span
                  className={[
                    'rounded-full border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider',
                    STATUS_CHIP[t.status]?.cls || STATUS_CHIP.archived.cls,
                  ].join(' ')}
                >
                  {STATUS_CHIP[t.status]?.label || t.status}
                </span>
              </header>
              <div className="space-y-2 px-4 py-3">
                <p className="font-serif italic text-sm text-fg-secondary">{t.tagline}</p>
                <Link
                  to={t.slideshow_path}
                  className="inline-block rounded-md border border-action bg-action px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider text-action-fg"
                >
                  open slideshow ↗
                </Link>
              </div>
            </li>
          ))}
        </ul>
        <p className="mt-6 px-1 text-xs italic text-fg-tertiary">
          Each completed trip&apos;s slideshow URL is permanent. Add a new trip by writing
          /trips/{'{'}trip-id{'}'}/{'{'}trip,challenges,activities,…{'}'}.json and pushing — the
          framework picks it up.
        </p>
      </main>
    </div>
  );
}
